import React, { FC } from 'react';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import UserApplicationPageContainer from '@buyside/components/container/UserApplication/userApplicationPageContainer';

const UserApplicationPageRoot: FC<{
  existingApplication?: string;
  email: string;
  firstName: string;
  lastName: string;
}> = ({ existingApplication, email, firstName, lastName }) => {
  const parsedExistingApplication = existingApplication ? JSON.parse(existingApplication) : null;

  return (
    <ErrorBoundary pageName="the user application">
      <UserApplicationPageContainer
        existingApplication={parsedExistingApplication}
        email={email}
        firstName={firstName}
        lastName={lastName}
      />
    </ErrorBoundary>
  );
};

export default UserApplicationPageRoot;
